<template>
  <div class="sheqingminyi">
    <div class="cont_service">
      <div class="cont_title">主要包含服务</div>
      <div class="s_main">
        <div class="m_left wow bounceInLeft">
          <img
            src="../../assets/img/productService/sheqingminyi/poster.png"
            alt="社情民意调查研究"
          />
        </div>
        <div class="m_right wow bounceInRight">
          <div class="m_title">
            <div class="title_zh">社情民意调查研究</div>
            <div class="title_en">SOCIAL SITUATION POLL RESEARCH</div>
          </div>
          <ul class="serviceList">
            <li class="s_item s_item_126">满意度调查</li>
            <li class="s_item s_item_240">城乡社会经济状况调查</li>
            <li class="s_item s_item_174">公益性社会调查</li>
            <li class="s_item s_item_126">绩效调查</li>
            <li class="s_item s_item_240">社情民意调查/社会舆论调查</li>
            <li class="s_item s_item_174">居民生活状况调查</li>
            <li class="s_item s_item_126">社会问题调查</li>
            <li class="s_item s_item_240">公共社会政策调研</li>
            <li class="s_item s_item_174">社会心理调查</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cont_case wow bounceInUp">
      <div class="cont_title">服务案例</div>
      <div class="c_main">
        <div class="m_info">
          <p class="info_desc">
            近年来承接的社情民意调查项目主要有：广东省级机关群众满意度调查、广州市第七次全国人口普查广告宣传点实地核查工作、广东省禁毒（国家级）（省级）重点区县预防整治工作社会成效评估调查、广州市新一轮交通综合调查——人员出行调查、广州市人力资源和社会保障基本情况调查、广州市中低收入职工家庭基本生活成本调查、广州市万户城市居民调查、广州市千户农村居民调查等。其中，广州市中低收入职工家庭基本生活成本调查多次为广州市最低工资标准制定提供了数据参考；广州市万户城市居民调查、广州市千户农村居民调查的调研报告更是获市委市政政府主要领导的多次批示。
          </p>
          <div class="imgBox">
            <img
              src="../../assets/img/productService/sheqingminyi/1.png"
              alt="..."
            />
            <img
              src="../../assets/img/productService/sheqingminyi/2.png"
              alt="..."
            />
            <img
              src="../../assets/img/productService/sheqingminyi/3.png"
              alt="..."
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sheqingminyi",
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
};
</script>
<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.cont_title {
  font-size: 18px;
  color: #333333;
  padding: 0 0 0 6px;
  border-left: 6px solid #406cdd;
}
.cont_service {
  width: $themeMinWidth;
  margin: 0 auto;
  .s_main {
    display: flex;
    justify-content: space-between;
    padding: 30px 0 0 0;
    .m_left {
      width: 563px;
      height: 234px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .m_right {
      width: 580px;
      .m_title {
        .title_zh {
          font-size: 20px;
          font-weight: bold;
          color: #333333;
        }
        .title_en {
          font-size: 16px;
          color: #999999;
          line-height: 24px;
        }
      }
      .serviceList {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .s_item {
          &.s_item_126 {
            width: 126px;
          }
          &.s_item_240 {
            width: 240px;
          }
          &.s_item_174 {
            width: 174px;
          }
          font-size: 16px;
          color: #333333;

          height: 30px;
          line-height: 30px;
          text-align: center;
          background-color: #ffffff;
          border: solid 1px #e5e5e5;
          margin: 30px 0 0 0;
        }
      }
    }
  }
}
.cont_case {
  padding: 30px 0 0 0;
  .cont_title {
    width: $themeMinWidth;
    margin: 0 auto;
    box-sizing: border-box;
  }
  .c_main {
    background-color: #f5f6f9;
    margin: 30px 0 0 0;
    .m_info {
      width: $themeMinWidth;
      margin: 0 auto;
      padding: 40px 0;
      display: flex;
      .info_desc {
        width: 484px;
        text-indent: 32px;
        font-size: 16px;
        color: #666666;
        line-height: 30px;
        text-align: justify;
      }
      .imgBox {
        width: 658px;
        display: flex;
        justify-content: space-between;
        padding: 0 0 0 40px;
      }
    }
  }
}
</style>
